import React, { useEffect, useState } from 'react';
import { db } from '../../../firebase';
import { collection, getDocs, query, where, Timestamp } from 'firebase/firestore';
import './AnalyticsStats.css';

const AnalyticsStats = ({ data }) => {
    const [totalVideoPurchases, setTotalVideoPurchases] = useState(null);
    const [totalGalleryLikes, setTotalGalleryLikes] = useState(null);
    const [newUsersThisMonth, setNewUsersThisMonth] = useState(null);

    useEffect(() => {
        // Total video purchases — sum purchaserEmails.length across all video_feed docs
        const fetchVideoPurchases = async () => {
            try {
                const snapshot = await getDocs(collection(db, 'video_feed'));
                const total = snapshot.docs.reduce((sum, doc) => {
                    const emails = doc.data().purchaserEmails || [];
                    return sum + emails.length;
                }, 0);
                setTotalVideoPurchases(total);
            } catch (e) {
                console.error('Error fetching video purchases:', e);
                setTotalVideoPurchases(0);
            }
        };

        // Total gallery likes — sum totalLikes across all gallery_config docs
        const fetchGalleryLikes = async () => {
            try {
                const snapshot = await getDocs(collection(db, 'gallery_config'));
                const total = snapshot.docs.reduce((sum, doc) => {
                    return sum + (doc.data().totalLikes || 0);
                }, 0);
                setTotalGalleryLikes(total);
            } catch (e) {
                console.error('Error fetching gallery likes:', e);
                setTotalGalleryLikes(0);
            }
        };

        // New users this month — users with createdAt >= 1st of current month
        const fetchNewUsersThisMonth = async () => {
            try {
                const now = new Date();
                const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
                const startTimestamp = Timestamp.fromDate(startOfMonth);
                const q = query(
                    collection(db, 'users'),
                    where('createdAt', '>=', startTimestamp)
                );
                const snapshot = await getDocs(q);
                setNewUsersThisMonth(snapshot.size);
            } catch (e) {
                console.error('Error fetching new users this month:', e);
                setNewUsersThisMonth(0);
            }
        };

        fetchVideoPurchases();
        fetchGalleryLikes();
        fetchNewUsersThisMonth();
    }, []);

    const {
        totalUsers = 0,
        subscriptionStatuses = {
            active: 0,
            pending_cancellation: 0,
            canceled: 0
        }
    } = data || {};

    const now = new Date();
    const monthName = now.toLocaleString('default', { month: 'long' });

    return (
        <div className="stats-summary">
            <div className="stat-card">
                <h4>Total Users</h4>
                <p className="stat-value">{totalUsers}</p>
            </div>
            <div className="stat-card">
                <h4>Active Pro Users</h4>
                <p className="stat-value">{subscriptionStatuses?.active || 0}</p>
            </div>
            <div className="stat-card pending-cancellation">
                <h4>Pending Cancellations</h4>
                <p className="stat-value">{subscriptionStatuses?.pending_cancellation || 0}</p>
            </div>
            <div className="stat-card canceled">
                <h4>Canceled Users</h4>
                <p className="stat-value">{subscriptionStatuses?.canceled || 0}</p>
                <small className="stat-note">All-time (forever)</small>
            </div>
            <div className="stat-card video-purchases">
                <h4>Video Purchases</h4>
                <p className="stat-value">
                    {totalVideoPurchases === null ? '…' : totalVideoPurchases}
                </p>
                <small className="stat-note">All-time (forever)</small>
            </div>
            <div className="stat-card gallery-likes">
                <h4>Gallery Likes</h4>
                <p className="stat-value">
                    {totalGalleryLikes === null ? '…' : totalGalleryLikes}
                </p>
                <small className="stat-note">Across all galleries</small>
            </div>
            <div className="stat-card new-users-month">
                <h4>New Users</h4>
                <p className="stat-value">
                    {newUsersThisMonth === null ? '…' : newUsersThisMonth}
                </p>
                <small className="stat-note">{monthName} so far</small>
            </div>
        </div>
    );
};

export default AnalyticsStats;
